<template>
  <div>
    <img id="myImage" :src="backgroundImagePath">

    <div>
      <div class="col-12" style="padding-top:15%">
        <img style="max-width:150px;width:100%" :src="logoPath"/>
      </div>

      <div class="col-12 fontTitle fontLandingTitle">
        {{ $t('title.landingPage') }}
      </div>

      <div class="col-12 fontContent fontLandingContent" v-if="tableCode">
        <p>{{ $t('text.landingPageWithTableId', {table: tableCode}) }}</p>
      </div>

      <div class="col-12 fontContent fontLandingContent" v-if="orderImmediate && ordersPossible">
        {{ $t('text.landingPageWithoutTableId') }}
      </div>

      <div class="col-12 fontContent fontLandingContent" v-if="orderImmediate && !ordersPossible">
        {{ $t('text.landingPageBlockedText') }}
      </div>

      <div class="col-12 btnLandingWrapper" v-if="ordersPossible">
        <b-button class="btn btnLanding" @click="doNavigationByAppMode" variant="primary">{{ $t('button.landingOrder') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Mode, Workflow} from "@/constants/constants";
import {useLocaleStore} from "../../stores/locale";
import {useAppStore} from "../../stores/app";
import {useOrderStore} from "../../stores/order";
import {useShopStore} from "@/stores/shop";
import orderMixin from "@/components/mixins/orderMixin";
import {useRegisterStore} from "@/stores/register";

export default {
  mixins: [orderMixin],
  data() {
    return {
      ordersPossible: true,
    };
  },
  props: {
    shopCode: {
      Type: Number
    },
    tableCode: {
      Type: String
    },
    orderImmediate: {
      Type: Boolean
    },
    isMealPlan: {
      Type: Boolean
    },
    cardNumber: {
      Type: String
    },
  },
  setup() {
    const localeStore = useLocaleStore();
    const appStore = useAppStore();
    const orderStore = useOrderStore();
    const shopStore = useShopStore();
    const registerStore = useRegisterStore();

    return {
      localeStore,
      appStore,
      orderStore,
      shopStore,
      registerStore
    };
  },
  computed: {
    backgroundImagePath() {
      return process.env.BASE_URL + 'settings/resources/LandingBackground.jpg';
    },
    logoPath() {
      return process.env.BASE_URL + 'settings/resources/logos/logo.png';
    },
  },
  methods: {
    async changeLanguage(newLocale) {
      await this.localeStore.setLocale(newLocale);
    },
    async doNavigationByAppMode() {
      if (this.shopCode) {
        if (this.orderImmediate) {
          await this.doImmediateOrder();
          await this.doCheckIfOrdersAreCurrentlyPossible();
          this.$navigateToMenu(true);
        } else if (this.tableCode) {
          Object.assign(window.config, window.configTablemode);

          await this.selectTableByQRCode(this.shopCode, this.tableCode);
          this.$navigateToMenu(true);
        } else {
          this.shopStore.setWondCode(this.shopCode);
          if (this.isMealPlan) {
            this.$navigateToMealPlanner(true);
          } else {
            this.$navigateToShop(true);
          }
        }
      } else if (this.cardNumber) {
        this.registerStore.setCardNumber(this.cardNumber);
        this.$navigateToRegister(true);
      } else {
        this.$navigateToErrorLanding();
      }
    },
  },
  created() {
    if (this.shopCode) {
      if (this.orderImmediate) {
        this.appStore.setWorkflow(Workflow.ORDER);
        this.appStore.setMode(Mode.IMMEDIATE);
      } else if (this.tableCode) {
        this.appStore.setWorkflow(Workflow.ORDER);
        this.appStore.setMode(Mode.TABLE);
      } else {
        if (this.isMealPlan) {
          this.appStore.setWorkflow(Workflow.MEAL_PLAN);
        } else {
          this.appStore.setWorkflow(Workflow.ORDER);
        }
        this.appStore.setMode(Mode.SHOP);
      }
    } else if (this.cardNumber) {
        this.appStore.setWorkflow(Workflow.DEFAULT);
        this.appStore.setMode(Mode.LOGIN);
    }
  }
};
</script>
